import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin",
  "use": "pin-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pin\"><path d=\"M2.167 0h8.666c.499 0 .825.287 1.084 1.143-.26-.409-.283-.316 0 0L9.75 3.429v3.428L13 9.143c.092.765.039 1.167 0 1.143-.405.332-.564.38-1.083 0-1.084.38-2.523.38-4.334 0C7.955 12.802 6.761 16 6.5 16c-.26 0-1.455-2.986-1.083-5.714-1.811.38-3.25.38-4.334 0-.757.38-1.083.094-1.083 0 0-.403.055-.543 0-1.143l3.25-2.286V3.43L1.083 1.143C1.241.593 1.397.21 2.167 0c-.204 0-.31.02 0 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol